import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Share2, Check, Copy, MessageCircle } from "lucide-react";

export default function ShareButton({ url, title, text, testid = "share-btn" }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const fullUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const shareText = text || t("profile.share_text", { name: title || "PK2 Scarlett" });

  const onClick = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: title || "PK2 Scarlett", text: shareText, url: fullUrl });
        return;
      } catch (_) {/* user cancelled */}
    }
    setOpen((v) => !v);
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_) {}
  };

  const enc = encodeURIComponent;
  const wa = `https://wa.me/?text=${enc(shareText + " " + fullUrl)}`;
  const tg = `https://t.me/share/url?url=${enc(fullUrl)}&text=${enc(shareText)}`;
  const tw = `https://twitter.com/intent/tweet?text=${enc(shareText)}&url=${enc(fullUrl)}`;

  return (
    <div className="relative inline-block" data-testid={`${testid}-wrap`}>
      <button
        type="button"
        onClick={onClick}
        className="btn-ghost text-xs inline-flex items-center gap-2"
        data-testid={testid}
      >
        <Share2 size={12} /> {t("profile.share")}
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 z-50 p-3 flex flex-col gap-2 min-w-[220px]"
          style={{ background: "var(--bg-elevated)", border: "1px solid var(--brand-primary)", boxShadow: "0 8px 32px rgba(0,0,0,0.6)" }}
          data-testid={`${testid}-popover`}
        >
          <a href={wa} target="_blank" rel="noreferrer" className="text-xs px-3 py-2 inline-flex items-center gap-2"
            style={{ background: "var(--bg-surface)", color: "var(--text-primary)" }} data-testid={`${testid}-whatsapp`}>
            <MessageCircle size={12} color="#25D366" /> WhatsApp
          </a>
          <a href={tg} target="_blank" rel="noreferrer" className="text-xs px-3 py-2 inline-flex items-center gap-2"
            style={{ background: "var(--bg-surface)", color: "var(--text-primary)" }} data-testid={`${testid}-telegram`}>
            <MessageCircle size={12} color="#0088cc" /> Telegram
          </a>
          <a href={tw} target="_blank" rel="noreferrer" className="text-xs px-3 py-2 inline-flex items-center gap-2"
            style={{ background: "var(--bg-surface)", color: "var(--text-primary)" }} data-testid={`${testid}-twitter`}>
            <Share2 size={12} /> X / Twitter
          </a>
          <button onClick={copy} className="text-xs px-3 py-2 inline-flex items-center gap-2"
            style={{ background: "var(--brand-primary)", color: "#fff" }} data-testid={`${testid}-copy`}>
            {copied ? <><Check size={12} /> {t("profile.copied")}</> : <><Copy size={12} /> {t("profile.copy_link")}</>}
          </button>
        </div>
      )}
    </div>
  );
}
